export default {
  label: 'Terminator linii',
  placeholder: 'Wybierz terminator linii',
};
